import React from 'react';
import styled from 'styled-components';
import { device } from '../utils/devices';

const AboutBlock = styled.div`
  padding: 10vw;
  font-size: 24px;
  line-height: 1.7em;

  @media ${device.laptop} {
    padding: 2rem 4rem 4rem;
    font-size: 24px;
    grid-column: 2/4;
  }
`;

const About = (props) => {
  return (
    <AboutBlock>
      YouDoYou Studio is a 1000 sq ft photo studio located in the East Village in Manhattan, New York. The space is basement level and has one flight of stairs. It is very private and excellent for producing studio lit projects, whether still or motion.
    </AboutBlock>
  )
}

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js